import * as React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "@emisgroup/ui-styles/dist/base.css";

const container = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <App />,
);
